// Local asset shipped with the admin build (ng-frontend/src/assets -> client/assets).
// Kept local so the admin's render path does not depend on a third-party host, which
// can be unreachable from a given browser (mixed content over HTTPS, ad blockers).
export const PLACEHOLDER_IMAGE = '/assets/images/image-not-found-150x150.png';

export interface ImageSlotConfig {
  key: string;
  showFor: (type: string) => boolean;
}

export const IMAGE_SLOTS: ImageSlotConfig[] = [
  { key: 'image1', showFor: () => true },
  { key: 'image2', showFor: (type: string) => type !== 'top 6' },
  { key: 'image3', showFor: (type: string) => type !== 'top 6' },
  { key: 'image4', showFor: (type: string) => type === 'solo' },
  { key: 'image5', showFor: (type: string) => type === 'solo' },
  { key: 'image6', showFor: (type: string) => type === 'solo' }
];

export function getPrizeType(
  prizeFormValue: any,
  index: number
): string {
  return prizeFormValue.prize[index]['type' + index];
}

export function getPrizeImageSrc(
  prizes: any[],
  index: number,
  slotKey: string,
  s3BucketUrl: string
): string {
  const prize = prizes && prizes[index];
  const imageObj = prize && prize[slotKey];

  if (imageObj && imageObj.type === 'embed') {
    const embedCode = imageObj.image || "";
    const match = embedCode.match(/embed\/([a-zA-Z0-9_-]+)/);
    if (match && match[1]) {
        return `https://img.youtube.com/vi/${match[1]}/0.jpg`;
    }
    return PLACEHOLDER_IMAGE;
  }

  if (imageObj && imageObj.image) {
    if (imageObj.image.startsWith('http') || imageObj.image.startsWith('data:')) return imageObj.image;
    return s3BucketUrl + imageObj.image;
  }

  return PLACEHOLDER_IMAGE;
}
